import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import MenuSidenavItem from '../menu-sidenav-item/menu-sidenav-item.component';
import styles from './menu-sidenav.style';
import menuItemsFun from '../../../config';
import cookie from 'react-cookies';
import Api from '../../../util/Api';
import AuthApi from '../../../util/AuthApi';
import SharedService from '../../../services/SharedService';

class MenuSidenav extends React.Component {
  state = { menuItems: [] };

  componentDidMount = async () => {
    const result = await menuItemsFun();
    const groupId = JSON.parse(await cookie.load('groupId'));
    await this.setState({ menuItems: result });
    if (groupId === 1) {
      await this.getProductTypList();
      SharedService.productTypeChanged.subscribe((value) => {
        if (value) this.getProductTypList();
      });
    }
  }

  getProductTypList = async () => {
    const { menuItems } = this.state;
    const endPoint = `${Api.productTypeUrl}?type=all&sort_direction=descending`;
    const { data, message } = await AuthApi.getDataFromServer(endPoint);
    if (data) {
      const arr = [];
      data.data.map((item) => {
        let link = (item.type_flag === 'special') ? '/dashboards/chooseMake' : `/dashboards/product/${item.id}`;
        arr.push({ title: item.title, href: link });
      });
      arr.unshift({ title: 'All Product Types', href: '/dashboards/productType' });
      menuItems.splice(1, 0, {
        title: 'Product Type',
        key: 'productType',
        // icon: <Make style={iconStyle} />,
        children: arr
      });
      this.setState({ menuItems });
    } else {
      // ToastsStore.error(message);
    }
  }

  constructNavItems = (itemsArray, classes) => {
    const arr = [];
    itemsArray.forEach((el) => {
      arr.push((
        <MenuSidenavItem
          title={el.title}
          href={el.href}
          key={el.title}
          icon={el.icon}
          type={el.type}
        >
          {el.children && this.constructNavItems(el.children, classes)}
        </MenuSidenavItem>));
    });
    return <List className={classes.list}>{arr}</List>;
  }

  render() {
    const { classes } = this.props;
    const { menuItems } = this.state;
    return (

      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          {this.constructNavItems(menuItems, classes)}
        </div>
      </div>

    );
  }
}

MenuSidenav.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

export default withStyles(styles)(MenuSidenav);



// WEBPACK FOOTER //
// ./src/layouts/components/menu-sidenav/menu-sidenav.component.js